import { Info } from 'lucide-react'
import type { AnswerInputProps } from '../QuestionRenderer'

const toneColor = {
  neutral: 'var(--form-accent,#6366F1)',
  accent: 'var(--form-accent,#6366F1)',
  success: '#059669',
  warning: '#D97706',
} as const

export function IntroBlock({ question }: AnswerInputProps<null>) {
  const tone = question.settings.layoutTone ?? 'neutral'
  const color = toneColor[tone]

  return (
    <div
      className="rounded-lg border p-5"
      style={{
        background: `color-mix(in srgb, ${color} 8%, var(--form-bg,#F8FAFC))`,
        borderColor: `color-mix(in srgb, ${color} 28%, transparent)`,
        borderRadius: 'var(--form-radius,8px)',
        color: 'var(--form-answer,#475569)',
        fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
        textAlign: question.settings.layoutAlignment ?? 'left',
      }}
    >
      <div className="mb-3 inline-flex items-center gap-2 text-sm font-semibold" style={{ color }}>
        <Info className="size-4" />
        {question.settings.calloutLabel ?? '填答說明'}
      </div>
      <div style={{ lineHeight: 'var(--form-line-height,1.55)' }}>
        {question.description || '請確認以下資訊後繼續填答。'}
      </div>
    </div>
  )
}
